import { findParentElement } from "src/standard/ts/findParentElement";
import invariant from "tiny-invariant";

export function findNextElement(element: HTMLElement, selector: string) {
  const matchingElements = Array.from(document.querySelectorAll(selector));

  const thisEl = findParentElement(element, selector);
  if (!thisEl) {
    if (matchingElements.length === 0) {
      // not found
      return undefined;
    }

    // Use first matching element
    return matchingElements[0] as HTMLElement;
  }

  const index = matchingElements.indexOf(thisEl);
  invariant(index > -1);

  if (index === matchingElements.length - 1) {
    // already at last
    return undefined;
  }

  return matchingElements[index + 1] as HTMLElement;
}
